import React from "react";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixHeaderProps } from "../types";

const PixHeader: React.FC<PixHeaderProps> = ({ paymentStatus, onClose }) => {
  const classes = usePixModalStyles();
  const isPending = paymentStatus === "pending";

  return (
    <div
      className={`${classes.header} ${
        isPending ? classes.headerPending : classes.headerConfirmed
      }`}
    >
      <h4 className={classes.headerTitle}>Pagamento via Pix</h4>

      <span
        className={`${classes.badge} ${
          isPending ? classes.badgePending : classes.badgeConfirmed
        }`}
      >
        <span
          className={`${classes.badgeDot} ${
            isPending ? classes.badgeDotPending : classes.badgeDotConfirmed
          }`}
        />
        {isPending ? "Aguardando" : "Confirmado"}
      </span>

      <IconButton
        size="small"
        className={classes.closeButton}
        onClick={onClose}
        aria-label="Fechar modal"
      >
        <CloseIcon style={{ fontSize: 16 }} />
      </IconButton>
    </div>
  );
};

export default PixHeader;
